(() => {
  const productReviewsList = document.getElementById('productReviewsList');
  const productReviewsPagination = document.getElementById('productReviewsPagination');

  const { productId } = document.getElementById('default').dataset;

  const onClickProductReviewsPagination = async evt => {
    const el = evt.target;
    if (el.tagName !== 'BUTTON') return;

    const body = JSON.stringify({ page: el.dataset.page, productId });
    try {
      const response = await fetch('/index.php?route=product/reviews', { method: 'POST', body });
      if (response.ok) {
        const responseData = await response.json();
        productReviewsList.innerHTML = responseData.list;
        productReviewsPagination.innerHTML = responseData.pagination;
        return;
      }
      throw new Error(`${response.status} ${response.statusText}`);
    } catch (err) {
      console.error(err);
    }
  };

  productReviewsPagination.addEventListener('click', onClickProductReviewsPagination);

  // ============================================================

  const list = document.querySelectorAll('[data-btn-reviews]');
  if (list) {
    const modalWindowReviews = () => {
      const form = document.createElement('form');
      form.classList.add('modal-window__form');

      const rating = document.createElement('div');
      rating.classList.add('rating-custom');
      rating.dataset.value = 3;
      rating.innerHTML = `
        <ul class="rating__list">
          <li class="rating__item"><span>Плохой</span></li>
          <li class="rating__item"><span>Так себе</span></li>
          <li class="rating__item"><span>Нормальный</span></li>
          <li class="rating__item"><span>Добрый</span></li>
          <li class="rating__item"><span>Великолепный</span></li>
        </ul>
      `;
      form.appendChild(rating);

      $(rating).rating({ max: 5, createNode: false });

      const formInputName = window.ModalWindow.createFormInput({
        title: 'Ваша фамилия и имя', name: 'name', placeholder: 'Iван Іванов', required: true
      });
      form.appendChild(formInputName);

      const formInputDescription = window.ModalWindow.createFormInput({
        title: 'Комментарий', name: 'description', placeholder: 'Комментарий', element: 'textarea'
      });
      form.appendChild(formInputDescription);

      const formBtn = window.ModalWindow.createFormBtn('Отправить сообщение');
      form.appendChild(formBtn);

      const onSubmit = async evt => {
        evt.preventDefault();
        evt.target.querySelector('.form-btn').disabled = true;

        const body = JSON.stringify({
          productId,
          name: form.name.value,
          description: form.description.value,
          rating: rating.dataset.value
        });

        let mwResponseText = 'Дякуємо за відгук. Він направлений адміністратору для перевірки на спам і незабаром буде опублікований';
        let mwResponseClass = 'success';
        const url = '/index.php?route=product/reviewAdd';
        try {
          const response = await fetch(url, { method: 'POST', body });
          if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
        } catch (err) {
          mwResponseText = `Помилка відправлення: ${err.message}`;
          mwResponseClass = 'error';
        }

        const mwResponse = document.createElement('div');
        mwResponse.classList.add('modal-window__response', `modal-window__response--${mwResponseClass}`);
        mwResponse.textContent = mwResponseText;

        const modalWindowBody = evt.target.closest('.modal-window__body');
        evt.target.remove();
        modalWindowBody.appendChild(mwResponse);
      };

      form.addEventListener('submit', onSubmit);

      new window.ModalWindow('Оставить отзыв', form);
    };

    // ============================================================

    const onClickBtn = async ({ target }) => {
      target.disabled = true;
      await modalWindowReviews();
      target.disabled = false;
    };

    // ============================================================

    list.forEach(el => el.addEventListener('click', onClickBtn));
  }
})();
